import { decamelizeKeys } from 'humps';
export function formatQueryParams(params) { const decamelizedParams = Object.entries(decamelizeKeys(params)); const activeParams = decamelizedParams.filter(([, value]) => value !== undefined); return new URLSearchParams(activeParams).toString(); }
